import LazyStandaloneSpaceSignupFlowContainer from "@pathwright/features/src/modules/space/signup/LazyStandaloneSpaceSignupFlowContainer"
import { Redirect } from "react-router-dom"

const SignupRoute = () => {
  return <LazyStandaloneSpaceSignupFlowContainer />
}

SignupRoute.path = "/sign-up/:licensor_id(\\d+)?/"

/** Old v1 store signup URLs land on the standalone flow. */
export const LegacySignupRedirect = (props) => (
  <Redirect
    to={
      props.location.pathname.replace("/sign-up/v1/", "/sign-up/") +
      props.location.search
    }
  />
)

LegacySignupRedirect.path = "/sign-up/v1/:licensor_id(\\d+)?/"

export default SignupRoute
